import { track } from "jiffy-analytics";
import { observeElementVisibility, isScrollOnTop } from "common/utils/ui/visibility";

import "./product-details-summary.scss";

export default () => {
  if (isScrollOnTop()) {
    observeElementVisibility(
      ".product-details-summary",
      (entries, scrolled) => {
        track("viewed_on_pdp", {
          target: "product_details",
          scrolled
        });
      },
      { mobileOnly: true, once: true } // tracked when half the element is visible
    );
  }
};
